import React from "react";
import ExternalPage from "./ExternalPage.jsx";
import MainResult from "./MainResult.jsx";

export default function Main_Page() {
  return (
    <div style={{minHeight:"70vh",backgroundColor:"#e7a31bff"}}>
        
      <ExternalPage />
       {/* <MainResult /> */}
     
    </div>
  );
}